var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sri-chart',{attrs:{"value":_vm.adaptedProduct}})
}
var staticRenderFns = []

export { render, staticRenderFns }